import { Box, Chip, Stack } from "@mui/material";
import { DmaMapContainer } from "./map-container";
import { useState } from "react";
import ParentSize from "@visx/responsive/lib/components/ParentSize";
import { DmaMapSearch } from "./dma-map-search";

export const DmaMap = ({
  hideInput = false,
  onSelect,
  selection,
  onRemove,
}: {
  hideInput?: boolean;
  onSelect?: (dma: string) => void;
  onRemove?: (dma: string) => void;
  selection?: string[];
}) => {
  const [location, setLocation] = useState<string[]>([]);
  const [preview, setPreview] = useState<string | null>(null);
  const selectedDmas = [
    ...((selection ?? location) || []),
    ...(preview ? [preview] : []),
  ]; // Ensure preview is included in the selected DMAs

  const handleDmaSelect = ({ dma, zip }: { dma: string; zip: string }) => {
    const dmaValue = dma?.toString();
    if (onSelect) {
      onSelect(dmaValue);
    } else if (!location?.includes(dmaValue)) {
      setLocation([...(location || []), dmaValue?.toString()]);
    }
    setPreview(null);
  };

  const handleDmaRemove = (dma: string) => {
    if (onRemove) {
      onRemove(dma);
    } else {
      setLocation(location?.filter((wl) => wl !== dma) || []);
    }
  };

  return (
    <Box sx={{ p: 2 }} className="site-wrapper">
      {!hideInput && (
        <Stack
          direction="row"
          className="dma-chips"
          spacing={1}
          flexWrap="wrap"
          sx={{
            minHeight: "32px",
            mb: 0.5,
          }}
        >
          {(selection ?? location)?.map((selectedLocation) => (
            <Chip
              key={selectedLocation}
              label={selectedLocation}
              onDelete={() => handleDmaRemove(selectedLocation)}
              sx={{ 
                py: 0.5, // 8px
                px: 0.5, // 8px
                minWidth: 'auto',
                width: 'fit-content',
                borderRadius: 50 
              }}
            />
          ))}
        </Stack>
      )}
      <Box
        className="dma-map-container"
        sx={{ width: "100%", margin: "0 auto", position: "relative" }}
      >
        {!hideInput && (
          <DmaMapSearch
            preview={preview}
            setPreview={setPreview}
            handleDmaSelect={handleDmaSelect}
          />
        )}

        <ParentSize>
          {({ width }) => (
            <DmaMapContainer
              width={width}
              height={width * 0.566}
              selectedDma={selectedDmas}
              onDmaClick={(dma) => setPreview(dma)}
            />
          )}
        </ParentSize>
      </Box>
    </Box>
  );
};
